import { render, staticRenderFns } from "./ContactTickets.vue?vue&type=template&id=dc3b9878&"
import script from "./ContactTickets.vue?vue&type=script&lang=js&"
export * from "./ContactTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports